/* Maison Scents — motion layer. Progressive: the page is complete without this file. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. Rolling labels on house buttons whose content is plain text */
  function rollLabels(root) {
    (root || document).querySelectorAll('.ms-btn:not([data-ms-rolled])').forEach(function (b) {
      b.setAttribute('data-ms-rolled', '');
      if (b.children.length || reduce) return;
      var t = b.textContent.trim();
      if (!t) return;
      b.textContent = '';
      var wrap = document.createElement('span');
      wrap.className = 'ms-roll';
      wrap.setAttribute('data-label', t);
      var inner = document.createElement('span');
      inner.textContent = t;
      wrap.appendChild(inner);
      b.appendChild(wrap);
    });
  }

  /* 2. Header state once the page moves */
  function watchScroll() {
    var root = document.documentElement, ticking = false;
    function set() { root.classList.toggle('ms-scrolled', window.scrollY > 24); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(set); } }, { passive: true });
    set();
  }

  /* 3. Scenting menu: the product appears beside the cursor */
  function menuPeek() {
    if (!fine || reduce) return;
    document.querySelectorAll('.ms-menu').forEach(function (menu) {
      var peek = menu.querySelector('.ms-menu__peek'), img = peek && peek.querySelector('img');
      if (!peek) return;
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null, last = 0;
      function loop() {
        cx += (tx - cx) * 0.12; cy += (ty - cy) * 0.12;
        var r = Math.max(-5, Math.min(5, (tx - cx) * 0.08));
        peek.style.setProperty('--x', cx + 'px'); peek.style.setProperty('--y', cy + 'px'); peek.style.setProperty('--r', r + 'deg');
        raf = Math.abs(tx - cx) + Math.abs(ty - cy) > 0.3 ? requestAnimationFrame(loop) : null;
      }
      menu.querySelectorAll('a[data-ms-img]').forEach(function (a) {
        new Image().src = a.getAttribute('data-ms-img');
        a.addEventListener('mouseenter', function () { img.src = a.getAttribute('data-ms-img'); menu.classList.add('is-peeking'); });
      });
      menu.addEventListener('mousemove', function (e) {
        var b = menu.getBoundingClientRect();
        /* float between the name and the price, never over either */
        tx = Math.min(Math.max(e.clientX - b.left + 90, b.width * 0.5), b.width - 190 - 130);
        ty = e.clientY - b.top - 120;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      menu.addEventListener('mouseleave', function () { menu.classList.remove('is-peeking'); });
      /* scrolling away under a still cursor never fires mouseleave */
      window.addEventListener('scroll', function () { if (menu.classList.contains('is-peeking') && !menu.matches(':hover')) menu.classList.remove('is-peeking'); }, { passive: true });
    });
  }

  /* 4. Headlines rise, eyebrows settle, photographs unveil — only below the fold, with a safety net */
  function reveals() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var root = document.documentElement;
    root.classList.add('ms-motion');
    var vh = window.innerHeight;
    var pending = [];
    document.querySelectorAll('main .ms-stack').forEach(function (h) {
      h.classList.add('ms-lines');
      [].forEach.call(h.children, function (line, i) {
        if (line.querySelector('.ms-line')) return;
        var inner = document.createElement('span'); inner.className = 'ms-line'; inner.style.setProperty('--i', i);
        while (line.firstChild) inner.appendChild(line.firstChild);
        line.appendChild(inner);
      });
      if (h.getBoundingClientRect().top > vh * 0.9) { h.classList.add('is-pending'); pending.push(h); }
      var eb = h.previousElementSibling;
      if (eb && eb.classList.contains('ms-eyebrow') && eb.getBoundingClientRect().top > vh * 0.9) { eb.classList.add('ms-fade', 'is-pending'); pending.push(eb); }
    });
    document.querySelectorAll('.ms-split .ms-photo, .ms-banner .ms-photo, .ms-story .ms-photo, .ms-trade .ms-photo, .ms-pdp-story .ms-photo').forEach(function (p) {
      if (p.getBoundingClientRect().top > vh * 0.9) { p.classList.add('ms-reveal-img'); pending.push(p); }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.remove('is-pending'); en.target.classList.add('is-in'); io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.01 });
    pending.forEach(function (el) { io.observe(el); });
    /* safety net: nothing stays hidden if the observer never fires (print, odd browsers, fast jumps) */
    window.addEventListener('beforeprint', function () { pending.forEach(function (el) { el.classList.remove('is-pending'); el.classList.add('is-in'); }); });
    setTimeout(function () {
      pending.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top < window.innerHeight) { el.classList.remove('is-pending'); el.classList.add('is-in'); } });
    }, 2500);
  }

  /* 5. Footer signature */
  function footerMark() {
    var f = document.querySelector('footer');
    if (!f || f.querySelector('.ms-footer-mark')) return;
    var m = document.createElement('p');
    m.className = 'ms-footer-mark'; m.setAttribute('aria-hidden', 'true');
    m.innerHTML = 'Maison <em>Scents</em>';
    f.appendChild(m);
  }

  function init() { rollLabels(); watchScroll(); menuPeek(); reveals(); footerMark(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.MSMotion = { rollLabels: rollLabels };
})();
